// Which ticks of a discrete slider get a numeric label: a short scale labels
// everything, a long one keeps the selected value, both ends and a regular
// stride. Neighbouring ticks sit ~17 px apart on the 220 px control while a
// label is up to 25 px wide, so two adjacent labels always collide; priority
// is selected > ends > stride and the lower one yields.
export const resolveSliceOptionTickLabels = ({
  maxLabels = 7,
  selectedIndex,
  values,
}: {
  maxLabels?: number;
  selectedIndex: number;
  values: number[];
}): boolean[] => {
  const lastIndex = values.length - 1;

  if (values.length <= maxLabels) {
    return values.map(() => true);
  }

  const stride = Math.ceil(lastIndex / (maxLabels - 1));
  const isNextTo = (index: number, other: number) =>
    Math.abs(index - other) === 1;

  return values.map((_, index) => {
    if (index === selectedIndex) {
      return true;
    }

    if (isNextTo(index, selectedIndex)) {
      return false;
    }

    if (index === 0 || index === lastIndex) {
      return true;
    }

    return (
      index % stride === 0 && !isNextTo(index, 0) && !isNextTo(index, lastIndex)
    );
  });
};
